export const OPTANON_CATEGORY_2 = 'optanonCategory2';
export const OPTANON_CATEGORY_3 = 'optanonCategory3';
export const OPTANON_CATEGORY_4 = 'optanonCategory4';

export type OptanonCategoryKey = (
    | typeof OPTANON_CATEGORY_2
    | typeof OPTANON_CATEGORY_3
    | typeof OPTANON_CATEGORY_4
);

export const OptanonCategories = {
  [OPTANON_CATEGORY_2]: 'optanon-category-C0002',
  [OPTANON_CATEGORY_3]: 'optanon-category-C0003',
  [OPTANON_CATEGORY_4]: 'optanon-category-C0004',
} as const satisfies Record<OptanonCategoryKey, string>;

/**
 * Window event dispatched whenever the user's cookie consent changes. OneTrust's
 * `OptanonWrapper` fires it on every consent update. Consent-gated client scripts
 * (SFMC, GAM, …) subscribe to react to opt-in; no single script owns the
 * callback, so each works independently of the others.
 */
export const CONSENT_CHANGED_EVENT = 'aw:consent-changed';
